/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-17 11:28:35
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-02-24 14:38:34
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorHeader/PromotionBarStyle/index.tsx
 */
import { getSalesChannelContentAnimation } from '@/src/request/salesChannel/content';
import { store } from '@/src/store';
import useRequest from '@ahooksjs/use-request';
import React from 'react';
import { useDispatch } from 'react-redux';
import { ItemWrapper } from 'src/components';
import { Checkbox, Input, Select } from 'src/components/Antd';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import Section from 'src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { useI18n } from 'src/hooks/useRouterChange';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import { AnimationType } from '../../SalesChannelEditorAnimation/tool';
import css from '../css.less';
import {
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getPromotionBarStyle,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onFixedFieldChange,
  resetConfig,
} from '../slice';
import {
  SalesChannelEditorHeaderEnum,
  errKey,
  filter,
  promotionBarStyleValidation,
} from '../tool';
function PromotionBarStyle(props: any) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, specificError, contentUuid } = props;
  const { data: animationData } = useRequest(() =>
    getSalesChannelContentAnimation(contentUuid),
  );
  const _d = useDispatch();

  const getEntranceEffect = (rawData: any) => {
    const { animationList } = rawData || {};
    const ani = Array.isArray(animationList)
      ? animationList
          .filter((v) => v.animationType === AnimationType.EntranceEffect)
          .map((v) => ({ label: v.name, value: v.uuid }))
      : [];
    const arr = [
      { label: getI18n('general.status.none'), value: null },
      ...ani,
    ];
    return arr;
  };
  return (
    <React.Fragment>
      <Section bottomBorder>
        <ItemWrapper title={getI18n('general.backgroundColour')}>
          <ColorPicker
            multi
            onChange={(v) => {
              _d(
                onFixedFieldChange({
                  path: 'promotionBarStyle.backgroundColor',
                  value: v,
                }),
              );
            }}
            color={data.backgroundColor}
          />
        </ItemWrapper>
        <ItemWrapper title={getI18n('general.textColour')}>
          <ColorPicker
            multi
            onChange={(v) => {
              _d(
                onFixedFieldChange({
                  path: 'promotionBarStyle.textColor',
                  value: v,
                }),
              );
            }}
            color={data.textColor}
          />
        </ItemWrapper>
        <ItemWrapper title={getI18n('salesChannelContent.index.dividerColour')}>
          <ColorPicker
            multi
            onChange={(v) => {
              _d(
                onFixedFieldChange({
                  path: 'promotionBarStyle.dividerColor',
                  value: v,
                }),
              );
            }}
            color={data.dividerColor}
          />
        </ItemWrapper>
      </Section>
      <Section bottomBorder>
        <ItemWrapper
          title={getI18n('salesChannelContent.index.promotionBarHeight')}>
          <Input
            suffix={'px'}
            size={'large'}
            customFilter={filter}
            value={data.height}
            error={
              specificError[errKey.height] &&
              specificError[errKey.height].length !== 0
            }
            help={specificError[errKey.height]?.join('')}
            onChange={(value) => {
              _d(
                onFixedFieldChange({
                  path: 'promotionBarStyle.height',
                  value,
                }),
              );
            }}
          />
        </ItemWrapper>
      </Section>
      <Section>
        <ItemWrapper
          title={getI18n('general.intervaltime')}
          containerClassName={css.intervalTime}>
          <Input
            error={
              specificError[errKey.intervalTime] &&
              specificError[errKey.intervalTime]?.length !== 0
            }
            help={specificError[errKey.intervalTime]?.join('')}
            size={'large'}
            onChange={(value) => {
              _d(
                onFixedFieldChange({
                  path: 'promotionBarStyle.intervalTime',
                  value,
                }),
              );
            }}
            value={data?.intervalTime}
            suffix={'seconds'}
          />
        </ItemWrapper>
      </Section>
      <Section bottomBorder>
        <ItemWrapper
          title={getI18n('salesChannelContent.index.entranceEffect')}>
          <Select
            error={
              specificError[errKey.entranceEffect] &&
              specificError[errKey.entranceEffect]?.length !== 0
            }
            help={specificError[errKey.entranceEffect]?.join('')}
            size={'large'}
            onChange={(value) => {
              _d(
                onFixedFieldChange({
                  path: 'promotionBarStyle.entranceEffect',
                  value,
                }),
              );
            }}
            value={data?.entranceEffect}
            options={getEntranceEffect(animationData)}
          />
        </ItemWrapper>
      </Section>
      <Section style={{ paddingBottom: '24px' }}>
        <Checkbox
          checked={data.stickToTop}
          onChange={(checked) => {
            _d(
              onFixedFieldChange({
                path: 'promotionBarStyle.stickToTop',
                value: checked,
              }),
            );
          }}>
          {getI18n('salesChannelContent.index.sticktotoponscroll')}
        </Checkbox>
      </Section>
    </React.Fragment>
  );
}

export default (props) =>
  ErrorProcessingHOC(PromotionBarStyle, {
    getCollapseOpenStatus,
    onCollapseOpen,
    expandOffset: props.isResponsive ? 0 : undefined,
    id: SalesChannelEditorHeaderEnum.promotionBarStyle,
    getContent: getPromotionBarStyle,
    title: getI18nFromGeneral('general.hOCTitle.promotionBarStyle'),
    getErrorDisplay: getCollapseValidationMsgDisplay,
    onErrorChange,
    getSubmitStamp,
    validation: (x) => {
      return promotionBarStyleValidation(x);
    },
    headerProps: {
      dotsFunction: [
        {
          onClick: () => {
            store.dispatch(resetConfig({ key: 'promotionBarStyle' }));
          },
          key: 'Reset Style',
          body: getI18nFromGeneral('general.hOCTitle.resetStyle'),
          isDangerous: true,
        },
      ],
      hasDots: true,
      hideDotsWhenNotPrimary: true,
    },
  })(props);
